module.exports = __webpack_public_path__ + "img/puppy-stock-image-1.852b08e1.jpg";